'use client'

import { Box, Typography, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslations } from 'use-intl'

type Props = {
    handleClose: () => void
}

export default function FareSelectionHeaderTitle({ handleClose }: Props) {
    const tFareFamily = useTranslations('fareFamily')

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', lineHeight: '1.6rem' }}>
            <Typography variant="h5" fontWeight="bold" lineHeight="2rem">
                {tFareFamily('fareFamilyTitle')}
            </Typography>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    color: (theme) => theme.palette.grey[700],
                    display: 'block',
                }}
            >
                <CloseIcon sx={{ fontSize: '1rem', width: '1.3rem', height: '1.3rem', fontWeight: 'bold' }} />
            </IconButton>
        </Box>
    )
}